module.exports = __webpack_public_path__ + "img/x-circle-fill.325accea.svg";